import { INTEGRATION_CODE } from "../../../../../models/IntegrationsTypes";
import { makeAutoObservable } from "mobx";
import { ICredentialsStore } from "../integration-store";
import IntegratorOAuthHandler from "./oauth-handler/integrator-oauth-handler";

export interface IAdyenOAuthCredentials {
    livePrefix: string;
}

class AdyenOAuthCredentialsStore implements ICredentialsStore {
    private _changes: IAdyenOAuthCredentials = { livePrefix: '' } as IAdyenOAuthCredentials;
    private _oauthHandler = new IntegratorOAuthHandler(INTEGRATION_CODE.ADYEN);
    private _isSandbox = false;
    constructor() {
        makeAutoObservable(this);
    }

    public get livePrefix() { return this._changes.livePrefix; }
    public set livePrefix(v: string) { this._changes.livePrefix = v; }

    public setIsSandbox(v: boolean) { this._isSandbox = v; }
    public get isSandbox(): boolean { return this._isSandbox; }

    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IAdyenOAuthCredentials;
    }

    getCredentials(isSandbox: boolean) {
        return this._oauthHandler.getCredentials(this._changes, isSandbox);
    }
}

export default AdyenOAuthCredentialsStore;